
<template>
  <div id="booklet_page" v-if="booklet.length > 0" style="overflow:hidden; height:100%;">  
      <flipbook class="flipbook" forwardDirection="left" :zooms="[1]" :pages="booklet" v-slot="flipbook">

        <div class="btns">
          <button style="margin-left:20px;" class="arr_right material-icons" @click="flipbook.flipLeft">chevron_right</button>
          <button class="arr_left material-icons" @click="flipbook.flipRight">chevron_left</button>
        </div>

      </flipbook>
  </div>
</template>

<script>
import Flipbook from 'flipbook-vue'
export default {
  components: { Flipbook },
  props: ["widgets", "item"],
  computed: {
      booklet() {
          var arr = [null];
          for (let i in this.item.booklet_gallery)
          {
              arr.push(this.item.booklet_gallery[i].url);
          }
         // arr.push(null)
          return arr;
      }
  },
  created(){
    
    
  }
}
</script>

<style lang="scss">
#booklet_page {
  position: relative;
  .flipbook { margin: 0 auto;
    width: 80%;
    height:70vh;
  }
  .btns {
    text-align:center; padding-top:10px; margin-bottom:25px;
    
    @media only screen and (max-width: 700px) {
      position: absolute;  top: 0px; margin: 0px; left: 0px; right: 0px;
    }

  }
  
}
</style>